import React, { useEffect } from 'react';
import useLanguageViewModel from '../view-model/use-language-view-model.tsx';
import { LanguageContextProvider } from './language-context-provider.ts';

export interface LanguageBaseProviderProps {
  children?: React.ReactNode;
}

export default function LanguageBaseProvider({ children }: LanguageBaseProviderProps) {
  // has to be in an own provider because of the LanguageViewModell needs the i18n context
  const languageViewModel = useLanguageViewModel({
    onLanguageChanged: () => onLanguageChanged(),
  });

  function onLanguageChanged() {
    //TODO do here stuff when language changed (like zod error mapping for ZOD)
  }

  // i18n is initial loading in the language provider because i18n needs an active language.
  useEffect(() => {
    languageViewModel.loadLanguage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LanguageContextProvider
      value={{
        currentLanguage: languageViewModel.currentLanguage,
        changeLanguage: languageViewModel.changeLanguage,
      }}
    >
      {children}
    </LanguageContextProvider>
  );
}
